var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classes,attrs:{"title":"Update"},on:{"click":function($event){return _vm.click(_vm.data)}}},[_c('span',[_c('font-awesome-icon',{attrs:{"icon":['far', 'eye']}})],1),_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }